// This file will validate the JSA Training information and also the JSA Training Employees information.

// Validating the JSA Training information, which will only include the ewiTrainerId, and the list of employees engaging in the training.
export const validateJsaTraining = (jsaTraining) => {
  const errors = {
    ewiTrainerId: null,
    jsaTrainingEmployeesInfo: null,
  };

  // Validating the ewiTrainerId, checking if the ewiTrainerYes is checked or not
  if (
    jsaTraining.ewiTrainerYes &&
    (!jsaTraining.ewiTrainerId || jsaTraining.ewiTrainerId.trim() === "")
  ) {
    errors.ewiTrainerId = "Please select an EWI Trainer";
  }
  // Validating the list of employees engaging in the training, checking if the handsOnJobTrainingYes is checked or not and if the employee list is empty or not
  if (jsaTraining.handsOnJobTrainingYes) {
    // Filter out completely empty rows (rows with no employee ID or name)
    const filledRows = jsaTraining.jsaTrainingEmployeesInfo.filter(
      (employee) => employee.employeeId || employee.employeeName
    );

    if (filledRows.length === 0) {
      errors.jsaTrainingEmployeesInfo =
        "Please fill out the list of employees that are training.";
    } else {
      // Going through each filled employee row and validating the employee id
      const trainingListErrors = [];
      filledRows.forEach((employee) => {
        const employeeError = {
          rowId: employee.rowId,
          errors: { employeeId: null },
        };
        if (!employee.employeeId) {
          employeeError.errors.employeeId = "Please select an employee";
        }
        if (employeeError.errors.employeeId) {
          trainingListErrors.push(employeeError);
        }
      });
      if (trainingListErrors.length > 0) {
        errors.jsaTrainingEmployeesInfo = trainingListErrors;
      }
    }
  }
  if (!errors.ewiTrainerId && !errors.jsaTrainingEmployeesInfo) {
    return {};
  } else {
    return errors;
  }
};
